// extracted by mini-css-extract-plugin
module.exports = {"snackBarContent":"notification_snackBarContent__12ilB","snackBarError":"notification_snackBarError__VWIDG"};